import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Promotion(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Promotion", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m3.52568 35.7819 3.80899-3.8081 6.34773 6.3477-3.809 3.809c-.33669.3366-.79328.5257-1.26936.5257-.47609 0-.93268-.1891-1.26937-.5257l-3.80899-3.809C3.18909 37.9848 3 37.5282 3 37.0521c0-.476.18909-.9335.52568-1.2702Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m7.337 31.9758 3.8063-16.5089 19.0495 19.0494-16.509 3.8063-6.3468-6.3468Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m18.1273 22.4512 5.0811 5.0811c.6738-.6738 1.0523-1.5876 1.0523-2.5405 0-.9529-.3785-1.8668-1.0523-2.5406-.6738-.6737-1.5877-1.0523-2.5406-1.0523-.9528 0-1.8667.3786-2.5405 1.0523ZM14.707 38.0804l7.864 7.855 1.2747-3.8063-5.0002-5.0003-4.1385.9516Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M25.568 2h-7.1817c-1.4286 0-2.7986.56748-3.8087 1.5776C13.5675 4.58773 13 5.95775 13 7.38628V9.1817c0 1.4285.5675 2.7986 1.5776 3.8087s2.3801 1.5776 3.8087 1.5776v3.5908l3.5908-3.5908h3.5909c1.4285 0 2.7985-.5675 3.8087-1.5776 1.0101-1.0101 1.5776-2.3802 1.5776-3.8087V7.38628c0-1.42853-.5675-2.79855-1.5776-3.80868C28.3665 2.56748 26.9965 2 25.568 2Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M26.0794 7.38625h-7.1817c-.2381 0-.4664-.09458-.6348-.26294C18.0946 6.95496 18 6.72662 18 6.48853c0-.23809.0946-.46642.2629-.63478.1684-.16835.3967-.26293.6348-.26293h7.1817c.2381 0 .4664.09458.6348.26293.1683.16836.2629.39669.2629.63478 0 .23809-.0946.46643-.2629.63478-.1684.16836-.3967.26294-.6348.26294Zm0 3.59085h-7.1817c-.2381 0-.4664-.0946-.6348-.2629-.1683-.1684-.2629-.3967-.2629-.6348 0-.2381.0946-.46644.2629-.63479.1684-.16836.3967-.26294.6348-.26294h7.1817c.2381 0 .4664.09458.6348.26294.1683.16835.2629.39669.2629.63479 0 .2381-.0946.4664-.2629.6348-.1684.1683-.3967.2629-.6348.2629Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M43.4165 19H30.7498c-.4199 0-.8226.1806-1.1196.5021-.2969.3215-.4637.7575-.4637 1.2122v.8571L25.9998 25h3.1667v4.2857c0 .4547.1668.8907.4637 1.2122.297.3215.6997.5021 1.1196.5021h12.6667c.4199 0 .8226-.1806 1.1196-.5021.2969-.3215.4637-.7575.4637-1.2122v-8.5714c0-.4547-.1668-.8907-.4637-1.2122-.297-.3215-.6997-.5021-1.1196-.5021Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41.0792 23.7954h-7.1817c-.2381 0-.4664-.0946-.6347-.2629-.1684-.1684-.263-.3967-.263-.6348 0-.2381.0946-.4664.263-.6348.1683-.1683.3966-.2629.6347-.2629h7.1817c.2381 0 .4665.0946.6348.2629.1684.1684.2629.3967.2629.6348 0 .2381-.0945.4664-.2629.6348-.1683.1683-.3967.2629-.6348.2629Zm0 3.5909h-7.1817c-.2381 0-.4664-.0946-.6347-.263-.1684-.1683-.263-.3966-.263-.6347 0-.2381.0946-.4665.263-.6348.1683-.1684.3966-.2629.6347-.2629h7.1817c.2381 0 .4665.0945.6348.2629.1684.1683.2629.3967.2629.6348 0 .2381-.0945.4664-.2629.6347-.1683.1684-.3967.263-.6348.263Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
Promotion.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Promotion"
};
validateTidalLicense();
export {
  Promotion
};
//# sourceMappingURL=Promotion.js.map
